import { state } from './types';

export default {
  [state.SELECTED_COHORTS]: [],
  [state.SELECTED_OUTCOME_VARIABLE]: null,
  [state.PAIRWISE_TUKEY_HSD_PVALS]: [],
};
